












































import { Vue, Component, Prop } from 'vue-property-decorator';
import { FieldType } from '@/models/Formidable/Field/field.abstract';
import FormidableForm from '@/components/FormidableForm.vue';
import { FormidableBasicForm } from '@/models/Formidable/Form/FormidableBasicForm';
import { FileType } from '@/models/Formidable/Field/FormidableFile';

const BASIC_FILE_FIELD = {
	fields: [
		{
			fieldType: FieldType.File,
			value: null,
			label: 'Any File'
		}
	]
};

const RESTRICTED_FILE_FIELDS: FormidableBasicForm = {
	fields: [
		{
			fieldType: FieldType.File,
			value: null,
			label: 'PDF',
			fileType: FileType.PDF
		},
		{
			fieldType: FieldType.File,
			value: null,
			label: 'Audio',
			fileType: FileType.Audio
		},
		{
			fieldType: FieldType.File,
			value: null,
			label: 'Video',
			fileType: FileType.Video
		}
	]
};

@Component({
	components: {
		FormidableForm
	}
})
export default class FormidableEmailDoc extends Vue {
	private basicFileFormConfig = BASIC_FILE_FIELD;
	private restrictedFileFormConfig = RESTRICTED_FILE_FIELDS;
}
